import { withStyles } from "@material-ui/styles";
import MuiTextField from "@material-ui/core/TextField";

// The dialog content sits on a grey surface, so every field in it gets a white
// background. Shared by the shell and both step bodies.
const TextField = withStyles({
  root: {
    background: "white",
  },
  expanded: {},
})(MuiTextField);

export default TextField;
